import { render, staticRenderFns } from "./view-examl.vue?vue&type=template&id=037dbc8a&scoped=true"
import script from "./view-examl.vue?vue&type=script&lang=js"
export * from "./view-examl.vue?vue&type=script&lang=js"
import style0 from "./view-examl.vue?vue&type=style&index=0&id=037dbc8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037dbc8a",
  null
  
)

export default component.exports